const transformHotelImages = (images) =>
  images.map((image) => {
    const { x500, webp_x620 } = image;

    return {
      jpg: x500,
      webp: webp_x620,
    };
  });

const transformHotel = (item) => {
  const hotel = {
    ...item.hotel,
    images: transformHotelImages(item.hotel.images),
  };

  return {
    ...item,
    hotel,
  };
};

export const transformHotels = (hotels) =>
  hotels.map((hotel) => transformHotel(hotel));
